
export default {
	props: {
		authService: {
			type: Object,
		},
	},
	data() {
		return {
			selectedCustomer: {},
			event: {
				show: false
			}
		};
	},
	methods: {
		async changeCustomer(idCustomer) {
			await this.authService.changeCustomer(idCustomer);
			this.$router.push("/");
		},
		async logout() {
			localStorage.removeItem("token");
			const currentUrl = window.location.href;
			window.location.href = `https://apps.gennera.com.br/public/#/login?url=${currentUrl}`;
		},
		home() {
			this.$router.push("/");
		}
	},
	mounted() {
		this.selectedCustomer.idCustomer = this.$session.customer.idCustomer;
		this.$emitter.on("eventEmitted", (event) => {
			this.event = event;
			setTimeout(() => {
				this.event.show = false;
			}, event.time);
		});
	}
};
